class LoadMoreButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", this.loadMore);
    }

    loadMore(event) {
        if (event.target.classList.contains("checked")) {
            document.querySelectorAll("#load-plans").forEach(el => el.classList.remove("checked"));
            document.querySelectorAll("#plan-available-text").forEach(el => el.innerText = "Are you outside the US or Canada?");
            document.querySelectorAll(".it-product-list--wrapper.regional").forEach(el => el.style.display = "block");
            document.querySelector(".it-product-list--wrapper.international").style.display = "none";
            document.querySelector(".component-hero--custom").style.display = "block";
        } else {
            document.querySelectorAll("#load-plans").forEach(el => el.classList.add("checked"));
            document.querySelectorAll("#plan-available-text").forEach(el => el.innerText = "In the US or Canada?");
            document.querySelectorAll(".it-product-list--wrapper.regional").forEach(el => el.style.display = "none");
            document.querySelector(".it-product-list--wrapper.international").style.display = "block";
            document.querySelector(".component-hero--custom").style.display = "none";
        }

        window.scrollTo(0,0);
    }
}

customElements.define("load-more-button", LoadMoreButton)